import React from 'react'
import { motion } from 'framer-motion'
import Bg from '../../Assets/images/ass1.png'
import Bgs from '../../Assets/images/ass2.png'
import Star from '../../Assets/images/star.svg'
import Constant from '../../Constant'
import Button from '../SelectValue/Button'

function TopSec() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
      className="body-bg"
    >
      <div className='pt-[140px] sm:pt-[177px] grid sm:grid-cols-3 gap-4'>
        
        <motion.div 
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          viewport={{ once: true }}
          className='sm:col-span-2 mb-10 px-6 sm:px-24'
        >
          <p className='inline-block bg-white p-3 text-[12px] font-[500] rounded-[32px] text-primary-color mb-4'>
            <img src={Star} alt='Star' className='inline' /> Empowering Ethics, Enriching Futures.
          </p>
          
          <h1 className='text-[24px] mb-6 font-[700] text-text-color1 sm:text-[48px]'>
            Own the Assets You Need, <span className={Constant.linearColor}>With Our Money</span>
          </h1>
          
          <p className='text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]'>
            From dreams to reality: get the assets you need today and pay back gradually without interest - always 100% halal.
          </p>

          <div className="flex flex-col sm:flex-row justify-right gap-4 mb-8">
            <Button name="Apply Now" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          viewport={{ once: true }}
          className="px-10 sm:pt-20"
        >
          <img src={Bg} alt='home' className='hidden sm:block' />
          <img src={Bgs} alt='home' className='sm:hidden block' />
        </motion.div>
      </div>
    </motion.section>
  )
}

export default TopSec
